import React, { ReactElement } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const DeleteIcon = (props: SvgIconProps): ReactElement => {
    return (
        <SvgIcon viewBox="0 0 20 20" fill="none" {...props}>
            <path
                d="M2.5 5H4.16667H17.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.66675 5.00008V3.33341C6.66675 2.89139 6.84234 2.46746 7.1549 2.1549C7.46746 1.84234 7.89139 1.66675 8.33342 1.66675H11.6667C12.1088 1.66675 12.5327 1.84234 12.8453 2.1549C13.1578 2.46746 13.3334 2.89139 13.3334 3.33341V5.00008M15.8334 5.00008V16.6667C15.8334 17.1088 15.6578 17.5327 15.3453 17.8453C15.0327 18.1578 14.6088 18.3334 14.1667 18.3334H5.83341C5.39139 18.3334 4.96746 18.1578 4.6549 17.8453C4.34234 17.5327 4.16675 17.1088 4.16675 16.6667V5.00008H15.8334Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
                fill="none"
            />
            <path
                d="M8.33325 9.16675V14.1667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.6667 9.16675V14.1667"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </SvgIcon>
    );
};
